export default __webpack_public_path__ + "static/media/404_page.2b95cbf6.png";